import React from "react";
import _ from "lodash";

import ModalWrapper from "../../../common/ModalWrapper";
import { NetworkAPI } from "apis";
import { FiDownload } from "react-icons/fi";

class BuildDetailsModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      input: null,
      downloadUrl: null,
    };

    this.handleDownload = this.handleDownload.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    try {
      const { networkId, buildId } = this.props;
      const { input, downloadUrl } = await NetworkAPI.getBuildDetails({
        networkId,
        buildId,
      });

      this.setState({
        input,
        downloadUrl,
      });
    } catch (err) {
      console.log(err);
    }
    this.setState({ isLoading: false });
  }

  handleDownload() {
    if (this.state.downloadUrl) {
      window.open(this.state.downloadUrl);
    }
  }

  render() {
    const { isLoading, input } = this.state;
    const { isOpenViewModal, handleClose, buildId, build } = this.props;

    return (
      <ModalWrapper
        isOpen={isOpenViewModal}
        showCloseFooter={true}
        handleClose={handleClose}
        title={
          <>
            <div className="border-b -mx-6 mb-4 px-6 pb-2 text-lg font-bold">
              {buildId}{" "}
              <span className="font-normal">
                ({build.packageName} version {build.packageVersion})
              </span>
            </div>
          </>
        }
      >
        <>
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            <>
              <div>
                <div className="flex items-center justify-center">
                  <button
                    type="button"
                    className="shadow rounded my-2 flex items-center gap-1 bg-blue-200 px-10 py-2 font-semibold text-blue-900 hover:bg-blue-300"
                    onClick={this.handleDownload}
                  >
                    <FiDownload></FiDownload>
                    Download build
                  </button>
                </div>

                <div className="text-lg font-semibold">Build Input:</div>
                <div className="overflow-y-auto" style={{ height: "360px" }}>
                  <textarea
                    className="w-full bg-gray-300 text-sm"
                    rows={20}
                    defaultValue={JSON.stringify(input, null, 4)}
                    readOnly
                  ></textarea>
                </div>
              </div>
            </>
          )}
        </>
      </ModalWrapper>
    );
  }
}

export default BuildDetailsModal;
